export const COMPARISON_TREE_BRANCH_IDS = new Set<string>([
  'main',
  'gwp',
  'fwd',
  'current',
  'after12',
  'next12',
  'all_time',
  'underwriting',
  'underwriting_last12',
  'underwriting_last6',
  'accident',
  'accident_last12',
  'accident_last6',
]);

interface TreeNode {
  id?: string;
  label?: string;
  children?: TreeNode[];
}

export type ComparisonTableValueOption = {
  value: string;
  label: string;
};

export function comparisonTableValueOptionsFromTree(tree: unknown): ComparisonTableValueOption[] {
  if (!tree || !Array.isArray(tree)) return [];
  const out: ComparisonTableValueOption[] = [];
  const seen = new Set<string>();

  const visit = (nodes: TreeNode[]) => {
    for (const n of nodes) {
      if (!n || typeof n !== 'object') continue;
      const kids = n.children;
      if (Array.isArray(kids) && kids.length > 0) {
        visit(kids);
        continue;
      }
      const id = n.id;
      if (typeof id !== 'string' || COMPARISON_TREE_BRANCH_IDS.has(id)) continue;
      if (seen.has(id)) continue;
      seen.add(id);
      const label =
        typeof n.label === 'string' && n.label.trim().length > 0 ? n.label.trim() : id;
      out.push({ value: id, label });
    }
  };

  visit(tree as TreeNode[]);
  return out;
}

export function comparisonTableValueMapPickerOptionsFromTree(tree: unknown): ComparisonTableValueOption[] {
  if (!tree || !Array.isArray(tree)) return [];
  const out: ComparisonTableValueOption[] = [];
  const seen = new Set<string>();

  const visit = (nodes: TreeNode[]) => {
    for (const n of nodes) {
      if (!n || typeof n !== 'object') continue;
      const kids = n.children;
      if (Array.isArray(kids) && kids.length > 0) {
        visit(kids);
        continue;
      }
      const id = n.id;
      if (typeof id !== 'string') continue;
      if (seen.has(id)) continue;
      seen.add(id);
      const label =
        typeof n.label === 'string' && n.label.trim().length > 0 ? n.label.trim() : id;
      out.push({ value: id, label });
    }
  };

  visit(tree as TreeNode[]);
  return out;
}

export function flattenComparisonTableColumnIds(tree: unknown): string[] {
  return comparisonTableValueOptionsFromTree(tree).map((o) => o.value);
}
